module.exports = __webpack_public_path__ + "img/github-logo.76d344f0.svg";